import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

interface SearchSectionProps {
  selectedField: string;
  setSelectedField: (value: string) => void;
  filterTerm: string;
  setFilterTerm: (value: string) => void;
  handleSearch: () => void;
}

export const SearchSection = ({
  selectedField,
  setSelectedField,
  filterTerm,
  setFilterTerm,
  handleSearch,
}: SearchSectionProps) => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const queryParam = searchParams.get("query");
    if (queryParam) {
      setFilterTerm(queryParam);
    }
  }, [searchParams, setFilterTerm]);

  const filterFields = [
    { value: "title", label: "Title" },
    { value: "slug", label: "Slug" },
    { value: "ean", label: "EAN" },
  ];

  return (
    <div className="mb-4 flex gap-4">
      <div className="w-32">
        <Select value={selectedField} onValueChange={setSelectedField}>
          <SelectTrigger>
            <SelectValue placeholder="Select field" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Fields</SelectItem>
            {filterFields.map((field) => (
              <SelectItem key={field.value} value={field.value}>
                {field.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex-1 flex gap-2">
        <Input
          placeholder={`Filter by ${selectedField === 'all' ? 'any field' : selectedField}...`}
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
        />
        <Button onClick={handleSearch}>
          Search
        </Button>
      </div>
    </div>
  );
};